
export default {
    name: 'LeeLuckGrid',
    inheritAttrs: false,
    data() {
        return {
            curindex: 0,
            haveClick: false
        }
    },
    mounted() {
        let that = this
        let axis = [[0, 0], [1, 0], [2, 0], [2, 1], [2, 2], [1, 2], [0, 2], [0, 1]];
        this.prizes.forEach(function (el, inx) {
            let x = axis[inx][0], y = axis[inx][1];
            that.$set(el, 'index', inx)
            that.$set(el, 'x', x)
            that.$set(el, 'y', y)
        })
    },
    computed: {
        styleLuckGrid() {
            let w = this.config.style.width;
            let h = this.config.style.height;
            let pd = this.config.style.padding;
            let bgColor = this.config.style.backgroundColor;
            let bgImg = this.config.style.backgroundImage;
            let radius = this.config.style.borderRadius;
            return {
                width: w + 'px',
                height: h + 'px',
                padding: pd + 'px',
                backgroundColor: bgColor,
                backgroundImage: " url(" + bgImg + ")",
                borderRadius: radius + 'px',
                '--fs': this.config.grid.fontSize,
                //'--color': this.config.grid.defaultStyle.fontColor,
            }
        },
        styleButton() {
            let w = (this.config.style.width - 2 * this.config.style.padding - 2 * this.config.style.gutter) / 3;
            let bgColor = this.btnConfig.background;
            let radius = this.config.style.borderRadius;

            let x = w + this.config.style.gutter
            let y = w + this.config.style.gutter


            return {
                width: w + 'px',
                height: w + 'px',
                background: bgColor,
                borderRadius: radius + 'px',
                left: x + 'px',
                top: y + 'px',
                pointerEvents: this.haveClick ? 'none' : ''

            }


        }
    },
    methods: {
        styleGrid(item) {
            let w = (this.config.style.width - 2 * this.config.style.padding - 2 * this.config.style.gutter) / 3;
            let bgColor = item.index == this.curindex ? this.config.grid.activeStyle.background : this.config.grid.defaultStyle.background;
            let fontColor = item.index == this.curindex ? this.config.grid.activeStyle.fontColor : this.config.grid.defaultStyle.fontColor;
            let radius = this.config.grid.borderRadius;
            let x = item.x * w + item.x * this.config.style.gutter
            let y = item.y * w + item.y * this.config.style.gutter
            let shadow=this.config.grid.shadow
            return {
                width: w + 'px',
                height: w + 'px',
                background: bgColor,
                borderRadius: radius + 'px',
                left: x + 'px',
                top: y + 'px',
                color: fontColor,
                boxShadow:typeof(shadow)==='boolean'?'none':shadow.x+'px '+shadow.y+'px 0px rgba(0,0,0,.2)'
                //'--iw': item.img.width
            }
        },
        click() {
            this.$emit('start');
            this.haveClick = true
        },
        play(inx) {
            let that = this
            let ci = 0
            let myst = setInterval(function () {
                that.curindex++
                if (that.curindex > 7) {
                    that.curindex = 0
                    ci++
                }
                if (ci > 6) {
                    clearInterval(myst)
                    let myst1 = setInterval(function () {
                        that.curindex++
                        if (that.curindex >= inx - 1) {
                            that.curindex = inx - 1
                            clearInterval(myst1)
                            setTimeout(() => {
                                that.$emit('end', inx - 1);
                                that.haveClick = false
                            }, 100)
                        }

                    }, 100)
                }

            }, 50)

        }
    },
    props: {
        btnConfig: {
            type: Object,
            default() {
                return {}
            }
        },
        config: {
            type: Object,
            default() {
                return {}
            }
        },
        prizes: {
            type: Array,
            default() {
                return []
            }
        }
    }

};
